// Usage: import * as Units from './lib/Units';
export function toArray(domElements) {
  return Array.prototype.slice.call(domElements, 0, domElements.length)
}

export const get = (selectors) => {
  return document.querySelector(selectors)
}
/**
 * Supports string, DOMElement, DOMElement[], Array
 *
 * getAll(document.body)
 * getall(document.querySelector('a'))
 * getAll('a')
 */
export const getAll = (selectors) => {
  if (typeof selectors === 'string') {
    return document.querySelectorAll(selectors)
  }

  if (selectors.length === undefined) return [selectors]

  return toArray(selectors)
}

export const bindAll = (selectors, eventName, callback) => {
  const domElements = getAll(selectors)

  domElements.forEach((el) => {
    el.addEventListener(eventName, callback)
  })

  return domElements
}

export const scrollTop = (elem) => {
  return elem && typeof elem.scrollTop === 'number'
    ? elem.scrollTop
    : window.pageYOffset || 0
}

export const hasClass = (el, className) => {
  if (el.classList) return el.classList.contains(className)
  else
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

export const addClass = (elements, className) => {
  getAll(elements).forEach((target) => {
    if (target.classList) {
      return target.classList.add(className)
    } else {
      return (target.className += ' ' + className)
    }
  })
}
export const removeClass = (elements, className) => {
  getAll(elements).forEach((target) => {
    if (target.classList) {
      return target.classList.remove(className)
    } else {
      return (target.className = target.className
        .split(' ')
        .filter((cl) => cl !== className)
        .join(' '))
      //target.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  })
}

export const arrayRemove = (array, element) => {
  const index = array.indexOf(element)
  array.splice(index, 1)
}

export const arrayShuffle = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}
/**
 * @example:
 * 	setClassIf({
 * 		'.slide-1': true,
 * 		'.slide-2': false
 * }, 'active');
 */
export function setClassIf(classObj, className) {
  Object.keys(classObj).forEach((selector) => {
    if (classObj[selector]) addClass(selector, className)
    else removeClass(selector, className)
  })
}

export const toggle = (elements, className) => {
  getAll(elements).forEach((target) => {
    return target.classList.toggle(className)
  })
}

export const isMobile = () => {
  return (
    (navigator.userAgent.match(/i(ad|od|phone)|android/) ? true : false) ||
    window.innerWidth <= 1050
  )
}

export const getVw = (pixels, viewportWidth) => {
  let vw_c = viewportWidth * 0.01 * 1
  return (pixels / vw_c) * 1 + 'vw'
}

export const closest = (num, arr) => {
  let mid,
    lo = 0,
    hi = arr.length - 1

  while (hi - lo > 1) {
    mid = Math.floor((lo + hi) / 2)
    if (arr[mid] < num) {
      lo = mid
    } else {
      hi = mid
    }
  }
  if (num - arr[lo] <= arr[hi] - num) {
    return arr[lo]
  }
  return arr[hi]
}

export function triggerClick(el) {
  // Create our event (with options)
  const event = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  })
  // If cancelled, don't dispatch our event
  const canceled = !el.dispatchEvent(event)
}

export function getParents(el, parentSelector) {
  if (parentSelector === undefined) {
    parentSelector = document
  }
  let parents = []
  let p = el.parentNode
  while (p !== parentSelector) {
    const o = p
    parents.push(o)
    p = o.parentNode
  }
  parents.push(parentSelector)
  return parents
}

export function deepAssign(target, ...sources) {
  for (let source of sources) {
    for (let k in source) {
      let vs = source[k],
        vt = target[k]
      if (Object(vs) == vs && Object(vt) === vt) {
        target[k] = deepAssign(vt, vs)
        continue
      }
      target[k] = source[k]
    }
  }
  return target
}

export const flattenNode = (node) => {
  const arr = Array.from(node.childNodes)
  return arr.reduce(flatReducer, [])
}

const flatReducer = (accumulator, currentValue) => {
  return accumulator.concat(
    currentValue.nodeType === Node.ELEMENT_NODE && !!currentValue.childNodes
      ? [].concat(currentValue).concat(flattenNode(currentValue))
      : currentValue
  )
}

export function flattenHtml(node, flat = [], tagsList = []) {
  tagsList.push(node)
  if (!node.childNodes.length) {
    let index =
      flat[flat.length - 1] === undefined
        ? 0
        : flat[flat.length - 1].index + flat[flat.length - 1].length
    flat.push({
      index: index,
      length: node.length ?? 1,
      text: node.wholeText ?? '',
      parents: [...tagsList],
    })
  } else {
    node.childNodes.forEach((child) => {
      flat = flattenHtml(child, flat, tagsList)
    })
  }
  tagsList.splice(tagsList.indexOf(node), 1)
  return flat
}

/**
 * This function split text into array including <br>
 * @params {string} txt This is text that retrieved from html element
 * @params {string} split It is separator for text (regex)
 * @return {Array.<string>} result of split using separator including <br>
 */

const splitText = (txt, split) => {
  const splits = txt.split('<br>')
  let arr = []
  splits.forEach(function (item, id) {
    if (id > 0) arr.push('<br>')
    arr = arr.concat(item.split(split))
  })
  return arr
}
